<style>
  input {
    background-color: #fff;
    box-sizing: border-box;
    flex: 1 1 auto;
    margin: 0.2em;
    padding: 0.3em;
    text-align: left;
    width: auto;
  }
  .columns {
    align-items: center;
    display: flex;
    flex-flow: row;
  }
  .do {
    font-size: 0.8em;
    margin: 0.3em 0.5em 0.5em 0.5em; /* top | right | bottom | left */
    padding: 0.4em;
    flex: 1 1 50%;
  }
  .first-row {
    align-items: center;
    display: flex;
    flex-flow: row;
  }
  .input_invalid {
    background-color: #fcc;
  }
  .item {
    align-items: left;
    background-color: #ffe;
    border-radius: 0.2em;
    border-width: 0em;
    box-shadow: 0.1em 0.1em 0.2em #555;
    display: flex;
    flex-flow: column;
    margin: 0.2em 0.4em 0.4em 0.4em; /* top | right | bottom | left */
    padding: 0.2em;
  }
  .more {
    cursor: pointer;
    flex: 0 0 auto;
    font-size: 0.8em;
    margin: 0.3em 0.5em 0.3em 0.3em; /* top | right | bottom | left */
    padding: 0.3em;
  }
  .name {
    cursor: pointer;
    flex: 1 1 auto;
    margin: 0em;
    padding: 0.5em;
  }
</style>

<script>
  import { afterUpdate, onMount } from 'svelte';
  import config from '../../config';
  import { 
    auth_logged_in,
    bookmarks, bookmark_selected,
    lang, leaflet_map,
    panel_selected,
  } from '../store';
  import sync from '../sync';
  import util from '../util';
  
  function delete_cancel(event) {
    delete_mode = false;
  }
  async function delete_confirm() {
    delete_mode = false;
    bookm_id = '';
    if ($auth_logged_in) {
      await sync.update_bookmark(bookm_obj, 'delete');
    } else {
      delete $bookmarks[bookm_seq];
      $bookmarks = $bookmarks;
    }
  }
  function delete_bookmark(event) {
    delete_mode = true;
  }
  function get_short_name(name) {
    if (name.length > display_name_len) {
      return name.substring(0, display_name_len - 1) + '...';
    } else {
      return name;
    }
  }
  function goto_bookmark(event) {
    let lat_long = {
      lat: bookm_obj.lat,
      lng: bookm_obj.long
    }
    $leaflet_map.setView(lat_long, bookm_obj.zoom);
    if (window.innerWidth < 800) {
      $panel_selected = '';
    }
  }
  function input_keypress(event) {
    if (event.key === 'Enter') {
      if (name_valid(rename_value)) {
        rename_confirm();
      }
    } else if (event.key === 'Escape') {
      rename_cancel();
    }
  }
  function name_valid(name) {
    if (
      name.length >= config.input.bookmark.name.min_len
      && name.length <= config.input.bookmark.name.max_len
    ) {
      return true;
    } else {
      return false;
    }
  }
  function rename_bookmark(event) {
    input_selected_once = false;
    rename_value = bookm_obj.bookm_name;
    rename_mode = true;
  }
  function rename_cancel(event) {
    rename_mode = false;
  }
  async function rename_confirm() {
    // leaving propagation on purpose
    rename_mode = false;
    if (bookm_obj.bookm_name !== rename_value && name_valid(rename_value)) {
      bookm_obj.bookm_name = rename_value;
      if ($auth_logged_in) {
        await sync.update_bookmark(bookm_obj, 'update');
      }
    }
  }
  function toggle_selected() {
    if ($bookmark_selected === bookm_id) {
      $bookmark_selected = '';
      rename_mode = false;
      delete_mode = false;
    } else {
      $bookmark_selected = bookm_id;
    };
  }
  function window_resize() {
    if (first_row && name) {
      if (window.innerWidth < 800) {
        var fontSize = parseFloat(window.getComputedStyle(name).getPropertyValue('font-size'));
        display_name_len = Math.floor((first_row.clientWidth - 65) / fontSize * 1.75);
      } else {
        display_name_len = default_display_name_len;
      }
    }
  }
  
  afterUpdate(() => {
    if ($bookmark_selected === bookm_id) {
      item.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    } else {
      rename_mode = false;
      delete_mode = false;
    }
    if (input && submit) {
      if (!input_selected_once) {
        input.focus();
        input.select();
        input_selected_once = true;
      };
      if (name_valid(rename_value)) {
        submit.disabled = false;
        input_invalid = false;
      } else {
        submit.disabled = true;
        input_invalid = true;
      }
    }
  });
  
  onMount(() => {
    window_resize();
  });
  
  export let item_id;
  const bookm_seq = item_id;
  
  let bookm_id = '';
  let bookm_obj = {};
  if (bookm_seq in $bookmarks) {
    bookm_id = $bookmarks[bookm_seq].bookm_id;
    bookm_obj = $bookmarks[bookm_seq];
  }
  
  const default_display_name_len = 29;
  let delete_mode = false;
  let display_name_len = default_display_name_len;
  let name;
  let input;
  let item;
  let first_row;
  let input_invalid = false;
  let input_selected_once;
  let rename_mode = false;
  let rename_value;
  let submit;
</script>

<svelte:window on:resize={window_resize}/>

{#if bookm_id}
  <div bind:this={item} class='item'>
    <div class='first-row' bind:this={first_row}>
      {#if rename_mode}
        <input class:input_invalid type='text' minlength={config.input.bookmark.name.min_len} maxlength={config.input.bookmark.name.max_len} bind:value={rename_value} on:keydown={input_keypress} bind:this={input}>
      {:else}
        {#key display_name_len}
          <p class='name' bind:this={name} on:click={goto_bookmark}>{get_short_name(bookm_obj.bookm_name)}</p>
        {/key}
      {/if}
      <p class='more' on:click={toggle_selected}>{$bookmark_selected === bookm_id ? util.caption($lang,'bookm_panel','less') : util.caption($lang,'bookm_panel','more')}</p>
    </div>
    {#if $bookmark_selected === bookm_id}
      <div class='columns'>
        {#if rename_mode}
          <button class='do orange' on:click={rename_confirm} bind:this={submit}>{util.caption($lang,'bookm_item','save')}</button>
          <button class='do green' on:click={rename_cancel}>{util.caption($lang,'bookm_item','cancel')}</button>      
        {:else if delete_mode}
          <button class='do red' on:click={delete_confirm}>{util.caption($lang,'bookm_item','confirm_del')}</button>
          <button class='do green' on:click={delete_cancel}>{util.caption($lang,'bookm_item','cancel')}</button>
        {:else}
          <button class='do green' on:click={rename_bookmark}>{util.caption($lang,'bookm_item','rename')}</button>
          <button class='do red' on:click={delete_bookmark}>{util.caption($lang,'bookm_item','delete')}</button>
        {/if}
      </div>
    {/if}
  </div>
{/if}
